import CityService from '../../service/city';

const Action = {
    GET_CITY: "GET_CITY",
    GET_CITIES: "GET_CITIES",
};

const ActionCreator = {
    getCity(cityId) {
        return async (dispatch) => {
            try {
                const city = await CityService.findById(cityId);
                dispatch({type: Action.GET_CITY, city});
                return city;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getCities() {
        return async (dispatch) => {
            try {
                const { cities, livingArea, continent } = await CityService.listAll()
                dispatch({type: Action.GET_CITIES, cities, livingArea, continent});
                return cities;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    cities: [],
    city: {},
    livingArea: [],
    continent: [],
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_CITY:
            return {
                ...state,
                city: action.city
            };
        case Action.GET_CITIES:
            const { cities, livingArea, continent } = action
            return {
                ...state,
                cities,
                livingArea,
                continent,
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/city.js